import { deleteCookie, getCookie, setCookie } from "@/utils/cookie.helpers";
import { NANI_DOMAIN, ONECLASS_DOMAIN, TOKEN_COOKIE_KEY } from "./constants";

export const getToken = (): string | null => {
  try {
    const cookie = getCookie(TOKEN_COOKIE_KEY);
    if (!cookie) return null;
    const { jwt } = JSON.parse(cookie);
    if (!jwt) return null;
    return jwt;
  } catch {
    return null;
  }
};

export const setToken = (token: string) =>
  setCookie(
    TOKEN_COOKIE_KEY,
    JSON.stringify({ code: "SUCCESS", jwt: token }),
    3
  );

export const deleteToken = () => deleteCookie(TOKEN_COOKIE_KEY);

export const isOneClassDomain =
  typeof window !== "undefined" &&
  window.location.hostname.includes(ONECLASS_DOMAIN);

export const isLocalhost =
  typeof window !== "undefined" && window.location.hostname === "localhost";

export const isNaniDomain =
  typeof window !== "undefined" &&
  window.location.hostname.includes(NANI_DOMAIN);
